import React, { useState, useEffect } from "react";
import { DivTag } from "../../../Components/Tags/Tags";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { HeadTag, InputField } from "../../../Components/Tags/Tags";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import GaugeChart from "react-gauge-chart";
import {
  checkExperianCreditReport2,
  V2VerifyMobile,
} from "../../../Services/EquifaxCScore/highmark";

import ExperianScoreReportModal from "./ExperianScoreReport";
import html2pdf from "html2pdf.js";
import { ExperianData, EV2MobileVerify, equifaxDataError } from "./data";
import Loader from "../../../Loader";
import { fetchProfile } from "../../../Services/profile/profileservice";
import { FaHandPointLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

const ExperianScore2 = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [cusName, setCusName] = useState();
  const [lastName, setlastName] = useState();
  const [dob, setDob] = useState();
  const [mobile, setMobile] = useState("");
  const [panNo, setPanNo] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditScore, setCreditScore] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [mobileResponseData, setMobileResponseData] = useState(null);
  const [afterVerifyMobPan, setAfterVerifyMobPan] = useState("");
  const [triggerVerifyContine, setTriggerVerifyContinue] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [ExperianReport, setExperianReport] = useState(null);
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null);
  const [submittedName, setSubmittedName] = useState("");
  const [afterMobName, setAfterMobName] = useState("");
  const [afterVerifyDOBMob, setAfterVerifyDOBMob] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(
    sessionStorage.getItem("verifyClicked") === "true",
  );

  const maxScore = 900;

  const isValidDate = (dateString) => {
    if (!dateString) return false;

    // Check if the date is in YYYY-MM-DD format (HTML date input format)
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateString)) return false;

    // Parse the date and check if it's valid
    const date = new Date(dateString);
    const timestamp = date.getTime();

    // Check if the date is invalid
    if (typeof timestamp !== "number" || Number.isNaN(timestamp)) {
      return false;
    }

    // Check if the date is not in the future
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) {
      return false;
    }

    // Check if the date is reasonable (not too old, e.g., before 1900)
    const minDate = new Date("1900-01-01");
    if (date < minDate) {
      return false;
    }

    // Check if the parsed date matches the input (prevents invalid dates like 2023-02-30)
    const [year, month, day] = dateString.split("-").map(Number);
    if (
      date.getFullYear() !== year ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      return false;
    }

    return true;
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate customer name
    if (!cusName) {
      newErrors.cusName = "Customer name is required.";
    }
    if (!lastName) {
      newErrors.lastName = "last name is required.";
    }

    if (mobile === "") {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (panNo === "") {
      newErrors.panNo = "PAN number is required.";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase())) {
      newErrors.panNo = "Enter a valid PAN number (e.g., ABCDE1234F).";
    }

    if (dob === "") {
      newErrors.dob = "Date of Birth is required.";
    } else if (!isValidDate(dob)) {
      newErrors.dob = "Enter a valid date of birth.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setExperianReport(null);
        showErrorToast( "Please correct the form errors.");
        return; // Exit if validation fails
      }
      // Call the CheckScore function to submit data
      setShowLoader(true);
      await AddHighmark();

      setTimeout(() => {
        // Hide the loader after 1 second
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      showErrorToast("Validate the Required Field");
      setShowLoader(false); // Hide loader in case of error
    }
  };

  const handleDownloadPDF = () => {
    setIsDownloading(true);
    setTimeout(() => {
      const element = document.getElementById("CreditReport");

      if (element) {
        element.classList.remove("hidden");
        const clonedElement = element.cloneNode(true);
        clonedElement.style.maxHeight = "none";
        clonedElement.style.overflow = "visible";
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.appendChild(clonedElement);
        document.body.appendChild(tempDiv);
        html2pdf()
          .from(clonedElement)
          .set({
            margin: [0.2, 0.2, 0.2, 0.2],
            filename: "ExperianV2Cr_Report.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2, backgroundColor: "white" },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
          })
          .save()
          .then(() => {
            document.body.removeChild(tempDiv);
            element.classList.add("hidden");
            setIsDownloading(false); // ✅ Stop loading
          })
          .catch(() => {
            showErrorToast("Failed to generate PDF");
            element.classList.add("hidden");
            setIsDownloading(false); // ✅ Stop loading
          });
      } else {
        showErrorToast("No data found to download");
      }
    }, 500);
  };

  async function AddHighmark() {
    try {
      setShowLoader(true);
      setIsLoading(true);

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_no: mobile,
        pan: panNo,
        first_name: cusName,
        dob: dob,
        last_name: lastName,
        consent: "Y",
      };

      const response = await checkExperianCreditReport2(payload);

      const statusCode = response?.status?.code || response?.status;

      if (
        statusCode === 403 &&
        statusCode.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        statusCode === 422
        
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast( response?.errors?.last_name?.[0] || response?.errors?.last_name?.[0] || "Insufficient balance in wallet.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return;
      }

      if (statusCode === 200) {
        const profile = response?.data?.result_json?.INProfileResponse;

        const score = profile?.SCORE?.BureauScore;

        setExperianReport(profile);

        // const inProfile = ExperianReport?.data?.result_json?.INProfileResponse;

        // if (!inProfile) {
        //   return <p>No data found in Experian report.</p>;
        // }

        setCreditScore(score);
        setSubmittedName(cusName);
        setCusName("");
        setMobile("");
        setPanNo("");

        showSuccessToast(
          response?.status?.message ||
            response?.message ||
            "Credit score fetched successfully.",
        );
      } else {
        setEquifaxv2Error(response?.error || response?.data || {});
        setExperianReport(null);
        showErrorToast(
          response?.data?.message ||
            response?.message ||
            response?.data?.error?.credit_report_message?.message ||
            response?.data?.error ||
            "Something went wrong.",
        );
      }
    } catch (error) {
      console.error("Error in Experian2:", error);
      setExperianReport(null);
      setEquifaxv2Error(error);
      showErrorToast("Something went wrong.");
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    }
    fetchProfileData();
  }, []);

  const handleVerifyMobile = async () => {
    const newErrors = {};

    // Only validate mobile
    if (!mobile.trim()) {
      newErrors.mobile = "Mobile is required";
    }
    if (!cusName) {
      newErrors.cusName = "First name is required";
    }
    if (!lastName) {
      newErrors.lastName = "Last name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true);
      setIsVerifyDisabled(true);
      sessionStorage.setItem("verifyClicked", "true");

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        first_name: cusName,
        last_name: lastName,
      };

      const response = await V2VerifyMobile(payload);

      if (
        response.status === 403 &&
        response.data.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");

        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "Insufficient balance."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");

        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");

        return;
      }

      setMobileResponseData(response || response?.data || response?.data?.data);
      if (response?.data?.result !== null) {
        showSuccessToast(
          response?.status?.message ||
            response?.message ||
            "Consumer Details Fetched",
        );
      } else {
        showErrorToast(
          response?.status?.message || response?.message || "No Records Found",
        );
      }

      setShowLoader(false);
      setIsLoading(false);
      setIsVerifyDisabled(false);
      setIsModalOpenMobile(true);
    } catch (error) {
      console.error("Error verifying Consumer:", error);
      setIsVerifyDisabled(false);
      setShowLoader(false);
      setIsLoading(false);
    }
  };

  // Reset on page load
  useEffect(() => {
    sessionStorage.removeItem("verifyClicked");
  }, []);

  const VerifyContinue = () => {
    setTriggerVerifyContinue(true);
    setIsModalOpenMobile(false);
  };

  useEffect(() => {
    if (triggerVerifyContine) {
      function convertToDateInputFormat(dateStr) {
        // Convert from DD-MM-YYYY to YYYY-MM-DD
        const [day, month, year] = dateStr.split("-");
        return `${year}-${month}-${day}`;
      }

      // Always set PAN and DOB
      setPanNo(afterVerifyMobPan);
      setDob(convertToDateInputFormat(afterVerifyDOBMob));

      // Only handle name splitting if name is available
      if (afterMobName) {
        const name = afterMobName || "";
        const nameParts = name.trim().split(" ");
        const firstNameFromName = nameParts[0] || "";
        const lastNameFromName =
          nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

        setCusName(firstNameFromName);
        setlastName(lastNameFromName);
      }

      // Reset trigger
      setTriggerVerifyContinue(false);
    }
  }, [
    triggerVerifyContine,
    afterVerifyMobPan,
    afterMobName,
    afterVerifyDOBMob,
  ]);

  // Helper function to format keys for display
  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .replace(/_/g, " ");
  };

  function convertDateForm(time) {
    let s = `${time}`;
    return s.slice(0, 4) + "/" + s.slice(4, 6) + "/" + s.slice(6, 8);
  }

  const safeGet = (obj, path, defaultValue = "N/A") => {
    if (!obj) return defaultValue;
    return path.split(".").reduce((current, key) => {
      return current && current[key] !== undefined && current[key] !== null
        ? current[key]
        : defaultValue;
    }, obj);
  };

  // Helper function to convert date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    if (convertDateForm) return convertDateForm(dateString);
    return dateString;
  };

  const stateCodeMap = {
    "01": "Andaman and Nicobar Islands",
    "02": "Andhra Pradesh",
    "03": "Arunachal Pradesh",
    "04": "Assam",
    "05": "Uttarakhand",
    "06": "Bihar",
    "07": "Chandigarh",
    "08": "Chhattisgarh",
    "09": "Dadra and Nagar Haveli",
    10: "Daman and Diu",
    11: "Delhi",
    12: "Goa",
    13: "Gujarat",
    14: "Haryana",
    15: "Himachal Pradesh",
    16: "Jammu and Kashmir",
    17: "Jharkhand",
    18: "Karnataka",
    19: "Kerala",
    20: "Ladakh",
    21: "Lakshadweep",
    22: "Madhya Pradesh",
    23: "Maharashtra",
    24: "Manipur",
    25: "Meghalaya",
    26: "Mizoram",
    27: "Nagaland",
    28: "Odisha",
    29: "Puducherry",
    30: "Punjab",
    31: "Rajasthan",
    32: "Sikkim",
    33: "Tamil Nadu",
    34: "Telangana",
    35: "Tripura",
    36: "Uttar Pradesh",
    37: "West Bengal",
    99: "Other",
  };

  const accountTypeMap = {
    "01": "Auto - Loan (Personal)",
    "02": "Housing Loan",
    "03": "Property Loan",
    "04": "Loan Against Shares/Securities",
    "05": "Personal Loan",
    "06": "Consumer Loan",
    "07": "Gold Loan",
    "08": "Education Loan",
    "09": "Loan to Professional",
    10: "Credit Card",
    11: "Leasing",
    12: "Overdraft",
    13: "Two-Wheeler Loan",
    14: "Non-Funded Credit Facility",
    15: "Loan Against Bank Deposits",
    16: "Fleet Card",
    17: "Commercial Vehicle Loan",
    18: "Telco – Wireless",
    19: "Telco – Broadband",
    20: "Telco – Landline",
    21: "Seller Financing",
    23: "GECL Loan Secured",
    24: "GECL Loan Unsecured",
    31: "Secured Credit Card",
    32: "Used Car Loan",
    33: "Construction Equipment Loan",
    34: "Tractor Loan",
    35: "Corporate Credit Card",
    36: "Kisan Credit Card",
    37: "Loan on Credit Card",
    38: "Prime Minister Jaan Dhan Yojana – Overdraft",
    39: "Mudra Loans – Shishu/Kishor/Tarun",
    40: "Microfinance – Business Loan",
    41: "Microfinance – Personal Loan",
    42: "Microfinance – Housing Loan",
    43: "Microfinance – Others",
    44: "Pradhan Mantri Awas Yojana - Credit Link Subsidy Scheme MAY CLSS",
    45: "P2P Personal Loan",
    46: "P2P Auto Loan",
    47: "P2P Education Loan",
    50: "Business Loan – Secured",
    51: "Business Loan – General",
    52: "Business Loan – Priority Sector – Small Business",
    53: "Business Loan – Priority Sector – Agriculture",
    54: "Business Loan – Priority Sector – Others",
    55: "Business Non-Funded Credit Facility – General",
    56: "Business Non-Funded Credit Facility-Priority Sector- Small Business",
    57: "Business Non-Funded Credit Facility-Priority Sector-Agriculture",
    58: "Business Non-Funded Credit Facility-Priority Sector-Others",
    59: "Business Loan Against Bank Deposits",
    61: "Business Loan – Unsecured",
    69: "Short Term Personal Loan",
    70: "Priority Sector- Gold Loan",
    71: "Temporary Overdraft",
    "00": "Other",
  };

  return (
    <>
      <Seo />
      {showLoader === true && <Loader />}

      <Header heading="Experian Credit Report (Version 2)" />

      <DivTag className="container grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-1 md:gap-2 p-2 bg-white  md:mt-1 mt-0 shadow-blue-600 rounded-md">
        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            First Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="cus_name"
            name="cus_name"
            value={cusName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter First Name"
            onChange={(e) => setCusName(e.target.value)}
          />
          {errors.cusName && (
            <p className="text-red-600 text-sm font-mono">{errors.cusName}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Last Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="last_name"
            name="last_name"
            value={lastName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter Last Name"
            onChange={(e) => setlastName(e.target.value)}
          />
          {errors.lastName && (
            <p className="text-red-600 text-sm font-mono">{errors.lastName}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <div className="flex items-center justify-between mb-1">
            <HeadTag className="text-md font-serif">
              Mobile <strong className="text-red-700">*</strong>
            </HeadTag>

            <button
              type="button"
              onClick={() => setIsModalOpenMobile(true)}
              className="text-sm bg-green-600 text-white px-1 rounded hover:bg-green-700"
            >
              View
            </button>
          </div>

          <div className="flex">
            <InputField
              type="text"
              placeholder="Enter Mobile"
              className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
              name="mobile"
              id="mobile"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />
            <button
              type="button"
              onClick={handleVerifyMobile}
              disabled={isVerifyDisabled}
              className={`bg-blue-600 text-white p-1 hover:bg-blue-700 ${isVerifyDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              Verify
            </button>
          </div>

          {errors.mobile && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.mobile}
            </p>
          )}

          {isModalOpenMobile && (
            <MobileDataModal
              setAfterMobName={setAfterMobName}
              mobileResponseData={mobileResponseData}
              setAfterVerifyMobPan={setAfterVerifyMobPan}
              setAfterVerifyDOBMob={setAfterVerifyDOBMob}
              VerifyContinue={VerifyContinue}
              onClose={() => setIsModalOpenMobile(false)}
            />
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            DOB<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="date"
            id="dob"
            name="dob"
            value={dob}
            max={new Date().toISOString().split("T")[0]}
            min="1900-01-01"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            onChange={(e) => setDob(e.target.value)}
          />
          {errors.dob && (
            <p className="text-red-600 text-sm font-mono">{errors.dob}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            {" "}
            Pan No. <strong className="text-red-700">*</strong>
          </HeadTag>
          <InputField
            type="text"
            placeholder="Enter Pan"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            name="pan_no"
            id="pan_no"
            value={panNo}
            onChange={(e) => setPanNo(e.target.value)}
          />
          {errors.panNo && (
            <p className="text-red-600 text-sm font-mono">{errors.panNo}</p>
          )}
        </DivTag>
      </DivTag>

      <div className="flex justify-center">
        <button
          className={`rounded-md p-1 bg-blue-700 text-white mt-8 mb-3 h-8 px-3 ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          onClick={handlesubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Get Score"}
        </button>
      </div>

      <div className="w-full text-center">
        {errors.identification && (
          <p className="text-red-600 text-sm font-mono">
            {errors.identification}
          </p>
        )}
      </div>

      {ExperianReport || Equifaxv2Error ? (
        <div className="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
          <span className="text-center font-bold md:text-xl">
            Hey{" "}
            {
              // Corrected data path for name display
              ExperianReport?.Current_Application?.Current_Application_Details
                ?.Current_Applicant_Details?.First_Name ||
                submittedName ||
                Equifaxv2Error?.data?.name ||
                Equifaxv2Error?.error?.name ||
                "User"
            }
            !
          </span>
          <h2 className="text-xl md:text-xl font-semibold text-center">
            Your Experian Credit Score
          </h2>

          <div className="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
            <div className="w-full md:w-[400px] relative md:mt-10">
              <span className="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70 top-[60px] left-5">
                Poor
              </span>
              <span className="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26 left-[69px] top-[-7px]">
                Average
              </span>
              <span className="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20 left-[12rem] mt-[-9px] rotate-20">
                Good
              </span>
              <span className="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70 ml-[16rem] mt-[3.5rem]">
                Excellent
              </span>

              <GaugeChart
                id="gauge-chart1"
                nrOfLevels={3}
                percent={creditScore / maxScore}
                needleColor={"#00008b"}
                textColor={"transparent"}
                needleBaseColor={"red"}
                arcsLength={[0.3, 0.3, 0.3, 0.3]}
                colors={["#cc0000", "#e6e600", "#cc6600", "#009900"]}
              />
              <p className="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] left-1/2 transform -translate-x-1/2">
                {creditScore}
              </p>
            </div>

            <div className="flex flex-col items-center md:items-start">
              <ul className="text-left text-sm md:text-base space-y-1 mt-4">
                {
                  // Corrected data path for Credit Account Summary
                  ExperianReport?.CAIS_Account?.CAIS_Summary?.Credit_Account &&
                    Object.entries(
                      ExperianReport.CAIS_Account.CAIS_Summary.Credit_Account,
                    ).map(([key, value], i) => (
                      <li key={i}>
                        <span className="font-bold">{formatKey(key)}</span>:{" "}
                        {value || "N/A"}
                      </li>
                    ))
                }
                {
                  // Corrected data path for Outstanding Balance
                  ExperianReport?.CAIS_Account?.CAIS_Summary
                    ?.Total_Outstanding_Balance &&
                    Object.entries(
                      ExperianReport.CAIS_Account.CAIS_Summary
                        .Total_Outstanding_Balance,
                    ).map(([key, value], i) => (
                      <li key={i}>
                        <span className="font-bold">{formatKey(key)}</span>:{" "}
                        {value || "N/A"}
                      </li>
                    ))
                }
              </ul>

              <ExperianScoreReportModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                ExperianReport={ExperianReport}
                Equifaxv2Error={Equifaxv2Error}
              />

              <div className="flex space-x-2 mt-4">
                <button
                  onClick={() => setModalOpen(true)}
                  className="bg-blue-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                >
                  View Details
                </button>

                {/* <button
                    className="bg-red-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                    onClick={handleDownloadPDF}
                    disabled={isDownloading}
                  >
                    {isDownloading ? "Downloading..." : "Download"}
                  </button> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="flex justify-center">
        <div className="flex flex-col items-center bg-gray-200 rounded-md shadow-lg shadow-blue-800 md:w-3/4 w-full p-1">
          <h1 className="font-bold text-2xl text-red-600 underline mb-2">
            Instructions
          </h1>
          <h2 className="text-xl font-bold text-center text-gray-800 mb-2 underline">
            How to get Best Financial Credit Report in Experian version 2 ?
          </h2>
          <p className="text-center text-gray-600 mb-2 font-semibold">
            Enter the Customer Mobile number & click on Verify, you will get the
            data against the
            <b /> entered mobile number then Proceed. If you didn’t get the
            details means you have to try with a different mobile number.
          </p>
          <p className="font-bold text-gray-700 mb-2">OR</p>{" "}
          {/* 👈 This line is added */}
          <ul className="list-decimal list-inside text-left text-gray-700">
            <li>Enter the correct customer’s First & Last name</li>
            <li>
              Enter the Mobile Number which is registered in credit bureau
              company.
            </li>
            <li>Enter the correct Date of Birth.</li>
            <li>Enter the correct PAN Number</li>
            <li>
              The Experian V2 credit Report only provide the details Report of
              that consumer which is available in the Experian Bureau.
            </li>
            <li>
              If you didn’t get the report means you should try with different
              details or in another bureau company.
            </li>
          </ul>
        </div>
      </div>

      <>
        <div
          id="CreditReport"
          className="hidden bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]"
        >
          {/* Check if ExperianReport exists */}
          {ExperianReport ? (
            <>
              <div className="a4-page">
                <div className="grid grid-cols-1 md:grid-cols-12">
                  <div className="col-span-2">
                    <img
                      src="/expLogo.webp"
                      className="w-24 p-1"
                      alt="Company Logo"
                    />
                  </div>
                  <div className="col-span-8 md:text-center text-center">
                    <h4 className="text-2xl font-bold">
                      {" "}
                      Experian Credit Report
                    </h4>
                  </div>
                  <div className="col-span-2 md:text-end text-end">
                    Consumer Credit Score:{" "}
                    <strong className="text-xl">
                      {safeGet(ExperianReport, "SCORE.BureauScore")}
                    </strong>
                  </div>
                </div>

                <div className="flex justify-between items-start flex-wrap">
                  {/* Start section */}
                  <div className="">
                    <p>
                      <i>Client ID:</i>{" "}
                      <span className="client_id">
                        {safeGet(ExperianReport, "client_id")}
                      </span>
                    </p>
                    <p>
                      <i>Report Order No:</i>{" "}
                      <span className="report_order_no">
                        {safeGet(
                          ExperianReport,
                          "CreditProfileHeader.ReportNumber",
                        )}
                      </span>
                    </p>
                  </div>

                  {/* End section */}
                  <div className="text-right">
                    <p>
                      <i>Date:</i>{" "}
                      <span className="report_date">
                        {formatDate(
                          safeGet(
                            ExperianReport,
                            "CreditProfileHeader.ReportDate",
                          ),
                        )}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="flex flex-col items-center justify-center my-4">
                  {Equifaxv2Error && (
                    <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                      <p className="text-center text-red-600 font-bold">
                        Error:{" "}
                        <span className="font-normal">
                          {
                            // Case 1: credit_report_message.message_code
                            Equifaxv2Error?.error?.credit_report_message?.message
                              ?.replace(/_/g, " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                              // Case 2: direct message
                              Equifaxv2Error?.message
                                ?.replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                              ExperianReport?.message
                                ?.replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                              "Unknown Error"
                          }
                        </span>
                      </p>
                      <p className="text-center text-red-600 font-bold mt-1">
                        Code:{" "}
                        <span className="font-normal">
                          {
                            // Case 1: credit_report_message.message_code
                            Equifaxv2Error?.error?.credit_report_message?.message_code
                              ?.replace(/_/g, " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                              // Case 2: direct message_code
                              Equifaxv2Error?.message_code
                                ?.replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                              ExperianReport?.message_code
                                ?.replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                              "Unknown code"
                          }
                        </span>
                      </p>
                    </div>
                  )}
                </div>

                <div className="flex justify-center">
                  <p className="font-bold text-black">Personal Details</p>
                </div>
                <div className="border border-blue-500 p-2 rounded-md">
                  <div className="grid grid-cols-2 md:grid-cols-2 gap-1">
                    {/* Consumer Name */}
                    <div>
                      <p>
                        <i>Consumer Name</i>
                        <span>
                          {" "}
                          :{" "}
                          {safeGet(
                            ExperianReport,
                            "Current_Application.Current_Application_Details.Current_Applicant_Details.First_Name",
                          )}
                        </span>
                      </p>
                    </div>

                    {/* Date of Birth */}
                    {(() => {
                      const firstDOB =
                        ExperianReport?.CAIS_Account?.CAIS_Account_DETAILS?.[0]
                          ?.CAIS_Holder_Details?.[0]?.Date_of_birth;
                      return (
                        <tr>
                          <td colSpan={6}>
                            <div className="mb-3">
                              <p>
                                <i>D.o.b</i>
                                <span>
                                  {" "}
                                  : {firstDOB ? formatDate(firstDOB) : "N/A"}
                                </span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })()}

                    {/* Gender */}
                    <div>
                      <p>
                        <i>Gender</i>
                        <span>
                          {" "}
                          :{" "}
                          {safeGet(
                            ExperianReport,
                            "Current_Application.Current_Application_Details.Current_Applicant_Details.Gender_Code",
                          )}
                        </span>
                      </p>
                    </div>

                    {/* Mobile Number */}
                    <div>
                      <p>
                        <i>Mobile</i>
                        <span>
                          {" "}
                          :{" "}
                          {safeGet(
                            ExperianReport,
                            "Current_Application.Current_Application_Details.Current_Applicant_Details.MobilePhoneNumber",
                          )}
                        </span>
                      </p>
                    </div>

                    {/* PAN */}
                    <div>
                      <p>
                        <i>PAN</i>
                        <span>
                          {" "}
                          :{" "}
                          {safeGet(
                            ExperianReport,
                            "Current_Application.Current_Application_Details.Current_Applicant_Details.IncomeTaxPan",
                          )}
                        </span>
                      </p>
                    </div>

                    {/* City */}
                    {(() => {
                      const city =
                        ExperianReport?.CAIS_Account?.CAIS_Account_DETAILS?.[0]
                          ?.CAIS_Holder_Address_Details?.[0]
                          ?.City_non_normalized;
                      return (
                        <tr>
                          <td colSpan={6}>
                            <div className="mb-3">
                              <p>
                                <i>State</i>
                                <span> : {city}</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })()}

                    {/* State */}
                    {(() => {
                      const stateCode =
                        ExperianReport?.CAIS_Account?.CAIS_Account_DETAILS?.[0]
                          ?.CAIS_Holder_Address_Details?.[0]
                          ?.State_non_normalized;

                      const stateName =
                        stateCodeMap[stateCode] || stateCode || "N/A";

                      return (
                        <tr>
                          <td colSpan={6}>
                            <div className="mb-3">
                              <p>
                                <i>State</i>
                                <span> : {stateName}</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })()}

                    {/* Country */}
                    <div>
                      <p>
                        <i>Country</i>
                        <span>
                          {" "}
                          :{" "}
                          {safeGet(
                            ExperianReport,
                            "Current_Application.Current_Application_Details.Current_Applicant_Address_Details.0.Country_Code",
                          )}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <hr className="my-2" />
                <div className="bg-blue-900 md:text-white text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl">
                  Address
                </div>
                {(() => {
                  const addresses =
                    ExperianReport?.CAIS_Account?.CAIS_Account_DETAILS?.[0]
                      ?.CAIS_Holder_Address_Details;

                  if (!Array.isArray(addresses) || addresses.length === 0)
                    return null;

                  return (
                    <tr>
                      <td colSpan={6}>
                        <div className="mb-3">
                          <table className="w-full table-auto border-collapse border">
                            <thead className="bg-blue-900 text-white">
                              <tr>
                                <th className="border px-2 py-1 text-left">
                                  SN.
                                </th>
                                <th className="border px-2 py-1 text-left">
                                  Full Address
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {addresses.map((addr, idx) => {
                                const fullAddress = [
                                  addr.First_Line_Of_Address_non_normalized,
                                  addr.Second_Line_Of_Address_non_normalized,
                                  addr.Third_Line_Of_Address_non_normalized,
                                  addr.City_non_normalized,
                                  addr.State_non_normalized,
                                  addr.ZIP_Postal_Code_non_normalized,
                                  addr.CountryCode_non_normalized,
                                ]
                                  .filter(Boolean)
                                  .join(", ");

                                return (
                                  <tr key={idx}>
                                    <td className="border px-2 py-1">
                                      {idx + 1}
                                    </td>
                                    <td className="border px-2 py-1">
                                      {fullAddress || "N/A"}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  );
                })()}

                {/* Account Details Section */}
                <div className="bg-blue-900 md:text-white text-white p-2 mt-4 rounded-tr-xl rounded-tl-xl">
                  Account Details
                </div>

                <table className="min-w-full table-auto text-left mt-2 border-collapse">
                  <tbody>
                    {ExperianReport &&
                      Array.isArray(ExperianReport) &&
                      ExperianReport.length > 0 && (
                        <tr>
                          <td colSpan={6} className="px-1 py-0">
                            <div className="flex flex-col gap-3 mt-1">
                              {ExperianReport.map((LinkedAC, idx) => {
                                const typeCode =
                                  LinkedAC?.Account_Type || "N/A";
                                const accountTypeName =
                                  accountTypeMap[typeCode] || "Not Specified";

                                return (
                                  <div
                                    key={idx}
                                    className="w-full border rounded-md p-1 bg-white shadow-sm"
                                  >
                                    {/* Heading */}
                                    <h3 className="bg-blue-900 md:text-white text-white p-1 rounded-tr-xl rounded-tl-xl text-sm">
                                      Loan Type : {accountTypeName}
                                    </h3>

                                    {/* Account Details */}
                                    <div className="grid grid-cols-3 gap-2 mb-2 text-xs">
                                      <div>
                                        <span className="font-semibold">
                                          Account Number:
                                        </span>{" "}
                                        {LinkedAC?.Account_Number || "N/A"}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Account Type:
                                        </span>{" "}
                                        {accountTypeName}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Subscriber Name:
                                        </span>{" "}
                                        {LinkedAC?.Subscriber_Name || "N/A"}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Date Reported:
                                        </span>{" "}
                                        {formatDate(LinkedAC?.Date_Reported)}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Date Closed:
                                        </span>{" "}
                                        {formatDate(LinkedAC?.Date_Closed)}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Last Payment Date:
                                        </span>{" "}
                                        {formatDate(
                                          LinkedAC?.Date_of_Last_Payment,
                                        )}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Overdue Amount:
                                        </span>{" "}
                                        ₹{LinkedAC?.Amount_Past_Due || "N/A"}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Current Balance:
                                        </span>{" "}
                                        ₹{LinkedAC?.Current_Balance || "N/A"}
                                      </div>
                                    </div>

                                    {/* Payment History */}
                                    <PaymentHistoryLists
                                      history={
                                        LinkedAC?.CAIS_Account_History || []
                                      }
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>

                <div class="overflow-y-auto">
                  <table class="min-w-full border border-gray-200 text-xs">
                    <thead class="bg-gray-100 sticky top-0">
                      <tr>
                        <th class="border border-gray-200 px-2 py-1 text-left w-14">
                          Code
                        </th>
                        <th class="border border-gray-200 px-2 py-1 text-left">
                          Account Type
                        </th>
                        <th class="border border-gray-200 px-2 py-1 text-left w-14">
                          Code
                        </th>
                        <th class="border border-gray-200 px-2 py-1 text-left">
                          Account Type
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">01</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Auto - Loan (Personal)
                        </td>
                        <td class="border border-gray-100 px-1 py-0">02</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Housing Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">03</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Property Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">04</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Loan Against Shares/Securities
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">05</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Personal Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">06</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Consumer Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">07</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Gold Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">08</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Education Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">09</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Loan to Professional
                        </td>
                        <td class="border border-gray-100 px-1 py-0">10</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Credit Card
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">11</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Leasing
                        </td>
                        <td class="border border-gray-100 px-1 py-0">12</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Overdraft
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">13</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Two-Wheeler Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">14</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Non-Funded Credit Facility
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">15</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Loan Against Bank Deposits
                        </td>
                        <td class="border border-gray-100 px-1 py-0">16</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Fleet Card
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">17</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Commercial Vehicle Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">18</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Telco – Wireless
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">19</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Telco – Broadband
                        </td>
                        <td class="border border-gray-100 px-1 py-0">20</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Telco – Landline
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">21</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Seller Financing
                        </td>
                        <td class="border border-gray-100 px-1 py-0">23</td>
                        <td class="border border-gray-100 px-1 py-0">
                          GECL Loan Secured
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">24</td>
                        <td class="border border-gray-100 px-1 py-0">
                          GECL Loan Unsecured
                        </td>
                        <td class="border border-gray-100 px-1 py-0">31</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Secured Credit Card
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">32</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Used Car Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">33</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Construction Equipment Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">34</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Tractor Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">35</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Corporate Credit Card
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">36</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Kisan Credit Card
                        </td>
                        <td class="border border-gray-100 px-1 py-0">37</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Loan on Credit Card
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">38</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Prime Minister Jaan Dhan Yojana – Overdraft
                        </td>
                        <td class="border border-gray-100 px-1 py-0">39</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Mudra Loans – Shishu/Kishor/Tarun
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">40</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Microfinance – Business Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">41</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Microfinance – Personal Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">42</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Microfinance – Housing Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">43</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Microfinance – Others
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">44</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Pradhan Mantri Awas Yojana - Credit Link Subsidy
                          Scheme MAY CLSS
                        </td>
                        <td class="border border-gray-100 px-1 py-0">45</td>
                        <td class="border border-gray-100 px-1 py-0">
                          P2P Personal Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">46</td>
                        <td class="border border-gray-100 px-1 py-0">
                          P2P Auto Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">47</td>
                        <td class="border border-gray-100 px-1 py-0">
                          P2P Education Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">50</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Loan – Secured
                        </td>
                        <td class="border border-gray-100 px-1 py-0">51</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Loan – General
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">52</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Loan – Priority Sector – Small Business
                        </td>
                        <td class="border border-gray-100 px-1 py-0">53</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Loan – Priority Sector – Agriculture
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">54</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Loan – Priority Sector – Others
                        </td>
                        <td class="border border-gray-100 px-1 py-0">55</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Non-Funded Credit Facility – General
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">56</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Non-Funded Credit Facility – Priority Sector
                          – Small Business
                        </td>
                        <td class="border border-gray-100 px-1 py-0">57</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Non-Funded Credit Facility – Priority Sector
                          – Agriculture
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">58</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Non-Funded Credit Facility – Priority Sector
                          – Others
                        </td>
                        <td class="border border-gray-100 px-1 py-0">59</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Loan Against Bank Deposits
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">61</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Business Loan – Unsecured
                        </td>
                        <td class="border border-gray-100 px-1 py-0">69</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Short Term Personal Loan
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">70</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Priority Sector- Gold Loan
                        </td>
                        <td class="border border-gray-100 px-1 py-0">71</td>
                        <td class="border border-gray-100 px-1 py-0">
                          Temporary Overdraft
                        </td>
                      </tr>
                      <tr>
                        <td class="border border-gray-100 px-1 py-0">00</td>
                        <td class="border border-gray-100 px-1 py-0">Other</td>
                        <td class="border border-gray-100 px-1 py-0"></td>
                        <td class="border border-gray-100 px-1 py-0"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Summary Section */}
                <div className="bg-blue-900 md:text-white text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl">
                  Summary
                </div>
                <ul className="min-w-full border border-black p-4">
                  {(() => {
                    const creditAccount = safeGet(
                      ExperianReport,
                      "CAIS_Account.CAIS_Summary.Credit_Account",
                    );
                    const outstandingBalance = safeGet(
                      ExperianReport,
                      "CAIS_Account.CAIS_Summary.Total_Outstanding_Balance",
                    );

                    return (
                      <>
                        {creditAccount &&
                          typeof creditAccount === "object" &&
                          Object.entries(creditAccount).map(
                            ([key, value], i) => (
                              <li key={`credit-${i}`} className="mb-1">
                                <span className="font-bold">
                                  {key || "N/A"}
                                </span>
                                : {value || "N/A"}
                              </li>
                            ),
                          )}
                        {outstandingBalance &&
                          typeof outstandingBalance === "object" &&
                          Object.entries(outstandingBalance).map(
                            ([key, value], i) => (
                              <li key={`balance-${i}`} className="mb-1">
                                <span className="font-bold">
                                  {key || "N/A"}
                                </span>
                                : {value || "N/A"}
                              </li>
                            ),
                          )}
                        {(!creditAccount ||
                          typeof creditAccount !== "object") &&
                          (!outstandingBalance ||
                            typeof outstandingBalance !== "object") && (
                            <li className="text-gray-500">
                              No summary data available
                            </li>
                          )}
                      </>
                    );
                  })()}
                </ul>
              </div>
            </>
          ) : (
            <p>No data available.</p>
          )}
        </div>
      </>
    </>
  );
};

const PaymentHistoryLists = ({ history }) => {
  if (!history || !Array.isArray(history) || history.length === 0) {
    return null;
  }

  return (
    <div className="w-full mb-2">
      <p className="font-bold mb-1 text-sm">Account History</p>

      {/* History Circles */}
      <div className="flex flex-wrap gap-3">
        {history.map((item, idx) => {
          const classification = item.Asset_Classification;
          const monthYear = `${item.Month}/${item.Year}`;

          let circleColor = "bg-gray-400"; // default
          let label = "Unknown";

          // Assign colors + labels
          switch (classification) {
            case "S":
              circleColor = "bg-green-500";
              label = "Standard";
              break;
            case "D":
              circleColor = "bg-red-500";
              label = "Default";
              break;
            case "P":
              circleColor = "bg-yellow-400";
              label = "Past Due";
              break;
            case "X":
              circleColor = "bg-blue-500";
              label = "Special";
              break;
            default:
              circleColor = "bg-gray-400";
              label = "Unknown";
          }

          return (
            <div
              key={idx}
              className="flex flex-col items-center p-1 border rounded-md w-16 text-center"
            >
              <div className={`w-4 h-4 rounded-full mb-1 ${circleColor}`}></div>
              <span className="text-[11px] font-medium">{monthYear}</span>
              <span className="text-[10px] text-gray-600">{label}</span>
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div className="flex gap-4 mt-3 text-xs flex-wrap">
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-full bg-green-500"></div>
          <span>Standard</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-full bg-red-500"></div>
          <span>Default</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
          <span>Past Due</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-full bg-blue-500"></div>
          <span>Special</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded-full bg-gray-400"></div>
          <span>Not Specified</span>
        </div>
      </div>
    </div>
  );
};

const AccountHolderDetails = ({ accountHolder, convertDateForm }) => {
  if (
    !accountHolder ||
    !Array.isArray(accountHolder) ||
    accountHolder.length === 0
  ) {
    return null;
  }

  return (
    <div className="w-full mb-4">
      <p className="font-bold">Account Holder Details</p>
      <table className="w-full border border-collapse">
        <thead className="bg-blue-900">
          <tr>
            <th className="border px-2 py-1 text-white">SN.</th>
            <th className="border px-2 py-1 text-white">Name</th>
            <th className="border px-2 py-1 text-white">PAN</th>
            <th className="border px-2 py-1 text-white">DOB</th>
          </tr>
        </thead>
        <tbody>
          {accountHolder.map((item, idx) => (
            <tr key={idx} className="border">
              <td className="border px-2 py-1">{idx + 1}</td>
              <td className="border px-2 py-1">
                {`${item.Surname_Non_Normalized || ""} ${item.First_Name_Non_Normalized || ""} ${item?.Middle_Name_1_Non_Normalized || ""}`.trim()}
              </td>
              <td className="border px-2 py-1">
                {item?.Income_TAX_PAN || "N/A"}
              </td>
              <td className="border px-2 py-1">
                {convertDateForm
                  ? convertDateForm(item.Date_of_birth)
                  : item.Date_of_birth || "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AccountHolderPhoneDetails = ({ phoneDetails, convertDateForm }) => {
  if (
    !phoneDetails ||
    !Array.isArray(phoneDetails) ||
    phoneDetails.length === 0
  ) {
    return null;
  }

  return (
    <div className="w-full mb-4">
      <p className="font-bold ">Account Holder Phone Details</p>
      <table className="w-full border border-collapse">
        <thead className="bg-blue-900">
          <tr>
            <th className="border px-2 py-1 text-white">SN.</th>
            <th className="border px-2 py-1 text-white">Mobile</th>
            <th className="border px-2 py-1 text-white">Fax</th>
            <th className="border px-2 py-1 text-white">Email</th>
          </tr>
        </thead>
        <tbody>
          {phoneDetails.map((item, idx) => (
            <tr key={idx} className="border">
              <td className="border px-2 py-1">{idx + 1}</td>
              <td className="border px-2 py-1">
                {item.Mobile_Telephone_Number || "N/A"}
              </td>
              <td className="border px-2 py-1">{item?.Fax_Number || "N/A"}</td>
              <td className="border px-2 py-1">{item?.EMailId || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AccountHolderIdDetails = ({ idDetails, convertDateForm }) => {
  if (!idDetails || !Array.isArray(idDetails) || idDetails.length === 0) {
    return null;
  }

  return (
    <div className="w-full mb-2">
      <p className="font-bold ">Account Holder ID Details</p>
      <table className="w-full border border-collapse">
        <thead className="bg-blue-900">
          <tr>
            <th className="border px-2 py-1 text-white">SN.</th>
            <th className="border px-2 py-1 text-white">PAN</th>
            <th className="border px-2 py-1 text-white">Email</th>
          </tr>
        </thead>
        <tbody>
          {idDetails.map((item, idx) => (
            <tr key={idx} className="border">
              <td className="border px-2 py-1">{idx + 1}</td>
              <td className="border px-2 py-1">
                {item.Income_TAX_PAN || "N/A"}
              </td>
              <td className="border px-2 py-1">{item?.EMailId || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AccountHolderAddressDetails = ({ addressDetails, convertDateForm }) => {
  if (
    !addressDetails ||
    !Array.isArray(addressDetails) ||
    addressDetails.length === 0
  ) {
    return null;
  }

  return (
    <div className="w-full mb-2">
      <p className="font-bold">Account Holder Address</p>
      <table className="w-full border border-collapse">
        <thead className="bg-blue-900">
          <tr>
            <th className="border px-2 py-1 text-white">SN.</th>
            <th className="border px-2 py-1 text-white">Line 1</th>
            <th className="border px-2 py-1 text-white">Line 2</th>
            <th className="border px-2 py-1 text-white">Line 3</th>
            <th className="border px-2 py-1 text-white">City</th>
          </tr>
        </thead>
        <tbody>
          {addressDetails.map((item, idx) => (
            <tr key={idx} className="border">
              <td className="border px-2 py-1">{idx + 1}</td>
              <td className="border px-2 py-1">
                {item?.First_Line_Of_Address_non_normalized || "N/A"}
              </td>
              <td className="border px-2 py-1">
                {item?.Second_Line_Of_Address_non_normalized || "N/A"}
              </td>
              <td className="border px-2 py-1">
                {item?.Third_Line_Of_Address_non_normalized || "N/A"}
              </td>
              <td className="border px-2 py-1">
                {item?.City_non_normalized || "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ExperianScore2;

const MobileDataModal = ({
  mobileResponseData,
  onClose,
  setAfterVerifyMobPan,
  setAfterMobName,
  setAfterVerifyDOBMob,
  VerifyContinue,
}) => {
  const rootData = mobileResponseData?.data || {};

  // Use useEffect to set the data properly
  useEffect(() => {
    if (rootData) {
      setAfterMobName(rootData?.name || "");
      setAfterVerifyMobPan(rootData?.pan || "");
      setAfterVerifyDOBMob(rootData?.dob || "");
    }
  }, [rootData, setAfterMobName, setAfterVerifyMobPan, setAfterVerifyDOBMob]);

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className="flex justify-between">
          <h2 className="text-2xl font-bold text-blue-700 border-b">
            Consumer Verification Details
          </h2>
          <button
            onClick={onClose}
            className="text-2xl text-red-600 hover:text-red-800"
          >
            ❌
          </button>
        </div>

        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className="text-xl text-green-600 font-semibold text-center">
              Found In Experian
            </h3>
            <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for
              better result
              <FaHandPointLeft className="text-lg" />
            </Link>
          </div>
        )}

        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-1 rounded-lg ${
              rootData.idspay_message === "success"
                ? "bg-green-100 border-green-300"
                : "bg-red-100 border-red-300"
            }`}
          >
            <p
              className={`text-md font-serif ${
                rootData.idspay_message === "success"
                  ? "text-green-600"
                  : "text-red-500"
              }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}
        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">
            Personal Info
          </h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p>
              <strong>Full Name:</strong> {rootData?.name || "N/A"}
            </p>
            <p>
              <strong>DOB:</strong> {rootData?.dob || "N/A"}
            </p>
            <p>
              <strong>Gender:</strong> {rootData?.gender || "N/A"}
            </p>
            <p>
              <strong>PAN:</strong> {rootData?.pan || "N/A"}
            </p>
            <p>
              <strong>Email:</strong> {rootData?.email || "N/A"}
            </p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">
            Addresses
          </h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[
                          address.first_line_of_address,
                          address.second_line_of_address,
                          address.third_line_of_address,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </td>
                      <td className="border px-2 py-1">
                        {address.state || "N/A"}
                      </td>
                      <td className="border px-2 py-1">
                        {address.postal_code || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-3 mt-3">
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
